import { render, staticRenderFns } from "./EditCommentModal.vue?vue&type=template&id=0828359d&"
import script from "./EditCommentModal.vue?vue&type=script&lang=js&"
export * from "./EditCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports